var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "navbar_message") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-253, -26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    transform: "translate(255, 26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7347254,2.4 C14.7990799,2.4 18.0938902,5.69481029 18.0938902,9.75916476 L18.0938902,13.2075133 L18.0938902,13.2075133 C18.0938902,14.1322755 18.3739389,14.8727902 18.9340363,15.4290574 C19.8360222,16.3922646 20.5207877,17.1158363 20.988333,17.5997724 C21.2577669,18.0184383 21.3590791,18.3488787 21.2922693,18.5910938 C21.2254596,18.8333088 20.9770182,19.0362775 20.5469451,19.2 L0.922505727,19.2 C0.523176052,19.1216509 0.251619833,18.9591195 0.107837071,18.7124056 C-0.0359456905,18.4656917 -0.0359456905,18.1622655 0.107837071,17.8021269 C1.01558761,16.8748003 1.7552744,16.0837771 2.32689744,15.4290574 C3.02600624,14.919726 3.37556065,14.1758467 3.37556065,13.1974195 L3.37556065,9.75916476 C3.37556065,5.69481029 6.67037094,2.4 10.7347254,2.4 Z",
    id: "\\u77E9\\u5F62",
    stroke: "#0E1C39",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5949342,0 L10.8745166,0 C11.8134007,-1.72470207e-16 12.5745166,0.761115925 12.5745166,1.7 C12.5745166,2.63888407 11.8134007,3.4 10.8745166,3.4 L10.5949342,3.4 C9.65605014,3.4 8.89493421,2.63888407 8.89493421,1.7 C8.89493421,0.761115925 9.65605014,1.14980138e-16 10.5949342,0 Z",
    id: "\\u77E9\\u5F62",
    fill: "#0E1C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4143078,20 C14.4143078,21.9882251 12.7669026,23.6 10.7347254,23.6 C8.70254817,23.6 7.05514303,21.9882251 7.05514303,20 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#0E1C39"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarMessage);
export default __webpack_public_path__ + "static/media/navbar_message.efa12dcc4035325a3a2f545e5c118eb0.svg";
export { ForwardRef as ReactComponent };